import { Component, input, output } from '@angular/core';

import { SvgIconComponent } from 'angular-svg-icon';

import { LinkListComponent } from '@valk-nx/components/ui-link-list/src/lib/link-list.component';
import type { LinkListItem } from '@valk-nx/components/ui-link-list/src/lib/link-list.interface';
import { cn } from '@valk-nx/core/lib/core';

@Component({
	selector: 'vp-bottom-sheet',
	templateUrl: './bottom-sheet.html',
	imports: [SvgIconComponent, LinkListComponent],
})
export class BottomSheetComponent {
	cn = cn;

	isOpen = input<boolean>(false);
	sheetItems = input<LinkListItem[]>();
	sheetTitle = input<string>('Sheet title');
	preventNavigation = input<boolean>(false);

	toggleSheet = output<void>();
	itemClicked = output<LinkListItem>();

	toggleEvent() {
		this.toggleSheet.emit();
	}

	onItemClicked(item: LinkListItem) {
		this.itemClicked.emit(item);
		this.toggleEvent();
	}
}
